import { IWorkoutResponse } from 'api/components/PersonalPlan/types';

import { YogaType } from 'constants/personalPlan';

import { DisconnectErrorCode, Events } from 'pages/big-screen/events';
import { ICompanionModeExercise } from 'pages/big-screen/components/CompanionPlayer/types';

export interface ISocketSendEventBase {
    event: SocketEvent;
}

export interface IWaitEvent {
    event_name: Events.WaitForUserAction;
}

export interface StartEvent {
    event_name: Events.Start;
    workout?: IWorkoutResponse;
    progress_time: number;
    companion_mode_session_id: string;
    yoga_type: YogaType | null;
    bg_audio: string | null;
}

export interface CompleteEvent {
    event_name: Events.Complete;
    fact_duration: number;
    fact_kcal: number;
    exercises_count: number;
}

export interface PlaybackEvent {
    event_name: Events.Playback;
    progress_time: number;
}

export interface PlayEvent {
    event_name: Events.Play | Events.Pause | Events.Next | Events.Previous;
}

export interface IDisconnectEvent {
    event_name: Events.Disconnect;
    error_code: DisconnectErrorCode;
}

export interface SystemEvent {
    event_name: Events.Exit | Events.Ready | Events.Ping | Events.Heartbeat;
}

export interface ISocketInitialConnect {
    token: string | null;
    signature: string | null;
}

export type SocketEvent =
    | StartEvent
    | CompleteEvent
    | PlaybackEvent
    | PlayEvent
    | SystemEvent
    | IWaitEvent
    | IDisconnectEvent;

export interface ISeekData {
    timeAfterSeekLeft: number;
    indexAfterSeek: number;
    localSeekTime: number;
}

export interface IChannelDeeplinkResponse {
    url: string;
    token: string;
    signature: string;
}

export interface IStartEventData extends Omit<StartEvent, 'workout' | 'event_name'> {
    exercises: ICompanionModeExercise[];
}

export enum BigScreenMediaTypes {
    BgMusic = 'bgMusic',
}
